import { useQuery } from '@tanstack/react-query';
import type { OAuthAuthorizeParams } from 'shared';

import { listOAuthGrants, previewOAuthAuthorization } from '../../lib/api/endpoints';

export const oauthKeys = {
  all: ['oauth'] as const,
  grants: () => [...oauthKeys.all, 'grants'] as const,
  preview: (params: OAuthAuthorizeParams | null) => [...oauthKeys.all, 'preview', params] as const,
};

export function useOAuthGrants() {
  return useQuery({ queryKey: oauthKeys.grants(), queryFn: listOAuthGrants });
}

export function useOAuthAuthorizePreview(params: OAuthAuthorizeParams | null) {
  return useQuery({
    queryKey: oauthKeys.preview(params),
    queryFn: () => {
      if (!params) throw new Error('Authorization request is missing.');
      return previewOAuthAuthorization(params);
    },
    enabled: params !== null,
    retry: false,
  });
}
